<template>
  <b-card
    no-body
    class="card-statistics"
  >
    <b-card-header>
      <b-card-title>Entites</b-card-title>
    </b-card-header>
    <b-card-body class="statistics-body">
      <b-row>
        <b-col
          v-for="item in statisticsItems"
          :key="item.icon"
          md="4"
          sm="6"
          class="mb-2 mb-md-0"
          :class="item.customClass"
        >
          <b-media no-body>
            <b-media-aside

              class="mr-2"
            >
              <b-avatar
                size="48"
                :variant="item.color"
              >
                <feather-icon
                  size="24"
                  :icon="item.icon"
                />
              </b-avatar>
            </b-media-aside>
            <b-media-body class="my-auto">
              <h4 class="font-weight-bolder mb-0">
                {{ item.title }}
              </h4>
              <b-card-text class="font-small-3 mb-0">
                {{ item.subtitle }}
              </b-card-text>
            </b-media-body>
          </b-media>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>

<script>
import {
  BCard, BCardHeader, BCardTitle, BCardText, BCardBody, BRow, BCol, BMedia, BMediaAside, BAvatar, BMediaBody,
} from 'bootstrap-vue'
import { API } from 'aws-amplify'
import * as queries from '../../graphql/queries'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardTitle,
    BCardText,
    BCardBody,
    BMedia,
    BAvatar,
    BMediaAside,
    BMediaBody,
  },
  data() {
    return {
      statisticsItems: [
        {
          icon: 'CpuIcon',
          title: '0',
          subtitle: 'Devices',
          customClass: 'mb-2 mb-sm-0',
        },
        {
          icon: 'BoxIcon',
          title: '0',
          subtitle: 'Objects',
          customClass: 'mb-2 mb-xl-0',
        },
        {
          icon: 'MapPinIcon',
          title: '0',
          subtitle: 'Sites',
          customClass: 'mb-2 mb-xl-0',
        },

      ],
    }
  },
  created() {
    this.getWorkspace()
  },
  methods: {
    async getWorkspace() {
      const workspaceId = JSON.parse(localStorage.getItem('workspace')).id
      const workspace = await API.graphql({
        query: queries.getWorkspace,
        variables: { id: workspaceId },
      })
      this.statisticsItems[0].title = workspace.data.getWorkspace.devices.items.length
      this.statisticsItems[1].title = workspace.data.getWorkspace.objects.items.length
      this.statisticsItems[2].title = workspace.data.getWorkspace.sites.items.length
    },
  },
}
</script>
